import * as React from 'react';
import styled from '../../../utils/styled';
import {MessageProps} from '../types';

interface RootProps extends Pick<MessageProps, 'intent'> {}

const Root = styled('div')<RootProps>(({theme}) => ({
  padding: 8,
  textAlign: 'center',
  '&:first-child': {
    marginTop: -8
  }
}));

const Main = styled('div')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.base,
  color: 'rgba(0,0,0,0.85)',
  lineHeight: '1.5',
  padding: '10px 16px',
  borderRadius: 4,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  background: '#fff',
  display: 'inline-block',
  pointerEvents: 'all'
}));

export default class Message extends React.Component<MessageProps, {}> {
  static defaultProps = {
    duration: 4500
  };

  private _closeTimer: NodeJS.Timer | null;

  public componentDidMount() {
    this._startCloseTimer();
  }

  public componentWillUnmount() {
    this._clearCloseTimer();
  }

  public render() {
    return (
      <Root onMouseEnter={this._clearCloseTimer} onMouseLeave={this._startCloseTimer}>
        <Main>{this.props.message}</Main>
      </Root>
    );
  }

  private _close = () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose(this.props);
    }
  };

  private _startCloseTimer = () => {
    this._closeTimer = setTimeout(() => {
      this._close();
      // tslint:disable-next-line:align
    }, this.props.duration!);
  };

  private _clearCloseTimer = () => {
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Messages/private/Message.tsx